import { useTheme } from "../../context/ThemeContext";

export default function AnalyticsTable({
    data,
}) {

    const { isDark } = useTheme();

    return (

        <div
            className={`
                overflow-hidden
                rounded-3xl
                border
                ${
                    isDark
                        ? "border-white/10"
                        : "border-gray-200"
                }
            `}
        >

            <table className="w-full">

                <thead
                    className={
                        isDark
                            ? "bg-white/5"
                            : "bg-gray-50"
                    }
                >

                    <tr>

                        <th className="p-4 text-left">
                            Banner
                        </th>

                        <th className="p-4 text-left">
                            Placement
                        </th>

                        <th className="p-4 text-left">
                            Impressions
                        </th>

                        <th className="p-4 text-left">
                            Clicks
                        </th>

                        <th className="p-4 text-left">
                            CTR
                        </th>

                    </tr>

                </thead>

                <tbody>

                    {data.length === 0 ? (

                        <tr>

                            <td
                                colSpan={5}
                                className="
                                    p-8
                                    text-center
                                    opacity-60
                                "
                            >
                                No analytics available.
                            </td>

                        </tr>

                    ) : (

                        data.map((banner) => (

                            <tr
                                key={banner.id}
                                className={`
                                    border-t
                                    ${
                                        isDark
                                            ? "border-white/10"
                                            : "border-gray-200"
                                    }
                                `}
                            >

                                <td className="p-4 font-medium">
                                    {banner.title}
                                </td>

                                <td className="p-4 capitalize">
                                    {banner.placement.replace("_", " ")}
                                </td>

                                <td className="p-4">
                                    {banner.impressions}
                                </td>

                                <td className="p-4">
                                    {banner.clicks}
                                </td>

                                <td className="p-4">

                                    <span
                                        className="
                                            rounded-full
                                            bg-cyan-100
                                            px-3
                                            py-1
                                            text-xs
                                            font-semibold
                                            text-blue-700
                                        "
                                    >
                                        {banner.ctr}%
                                    </span>

                                </td>

                            </tr>

                        ))

                    )}

                </tbody>

            </table>

        </div>

    );

}